<rid-odd-one-out
  class="h-dvh"
  [questions]="[
    { id: '1', question: 'Welk woord past er niet bij?', options: ['appel', 'prei', 'banaan', 'kaki'], answer: 2 },
    {
      id: '2',
      question: 'Welke zin past er niet bij?',
      options: ['ik heb een kat', 'hij heeft een hond', 'jij hebt een vis', 'zij had een cavia'],
      answer: 1,
    },
    { id: '3', question: 'Welk woord past er niet bij?', options: ['appel', 'prei', 'banaan', 'kaki'], answer: 2 },
    { id: '3.1', question: 'Welk woord past er niet bij?', options: ['appel', 'prei', 'banaan', 'kaki'], answer: 2 },
    {
      id: '4',
      question: 'Welke zin past er niet bij?',
      options: ['ik heb een kat', 'hij heeft een hond', 'jij hebt een vis', 'zij had een cavia'],
      answer: 1,
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/odd-one-out'])"
/>
